import PropTypes from "prop-types";


export const ColorVariantPropType = PropTypes.shape({
    url: PropTypes.string.isRequired,
    thumbnail_url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    in_stock: PropTypes.bool.isRequired,
});
